import { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { getAppById } from '../data/apps';
import { localized } from '../utils/localized';
import './SupportForm.css';

const SUPPORT_EMAIL = 'livstudiodev@yandex.by';

function SupportForm({ selectedAppId }) {
  const { t, locale } = useLanguage();
  const selectedApp = getAppById(selectedAppId);
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState('idle');

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const appName = localized(selectedApp.name, locale);
    const subject = encodeURIComponent(`[${appName}] ${form.subject}`);
    const body = encodeURIComponent(
      `${t('form.name')}: ${form.name}\n${t('form.email')}: ${form.email}\n${t('form.app')}: ${appName}\n\n${form.message}`
    );

    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;

    setStatus('success');
    setForm({
      name: '',
      email: '',
      subject: '',
      message: '',
    });
  };

  if (status === 'success') {
    return (
      <section id="support-form" className="support-form">
        <div className="support-form-success">
          <h2>{t('form.successTitle')}</h2>
          <p>{t('form.successText')}</p>
          <button type="button" onClick={() => setStatus('idle')}>
            {t('form.sendAnother')}
          </button>
        </div>
      </section>
    );
  }

  return (
    <section id="support-form" className="support-form">
      <h2 className="section-title">{t('form.title')}</h2>
      <p className="support-form-lead">
        {t('form.lead')}{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>

      <div className="support-form-selected-app">
        {selectedApp.icon ? (
          <img
            src={selectedApp.icon}
            alt=""
            width={40}
            height={40}
            className="support-form-selected-app-icon"
          />
        ) : (
          <div
            className="support-form-selected-app-icon support-form-selected-app-icon--placeholder"
            aria-hidden="true"
          />
        )}
        <div>
          <span className="support-form-selected-app-label">{t('form.app')}</span>
          <span className="support-form-selected-app-name">
            {localized(selectedApp.name, locale)}
          </span>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="support-form-fields">
        <div className="form-row">
          <label htmlFor="name">{t('form.name')}</label>
          <input
            id="name"
            name="name"
            type="text"
            required
            value={form.name}
            onChange={handleChange}
            placeholder={t('form.namePlaceholder')}
          />
        </div>

        <div className="form-row">
          <label htmlFor="email">{t('form.email')}</label>
          <input
            id="email"
            name="email"
            type="email"
            required
            value={form.email}
            onChange={handleChange}
            placeholder="you@example.com"
          />
        </div>

        <div className="form-row">
          <label htmlFor="subject">{t('form.subject')}</label>
          <input
            id="subject"
            name="subject"
            type="text"
            required
            value={form.subject}
            onChange={handleChange}
            placeholder={t('form.subjectPlaceholder')}
          />
        </div>

        <div className="form-row">
          <label htmlFor="message">{t('form.message')}</label>
          <textarea
            id="message"
            name="message"
            required
            rows={5}
            value={form.message}
            onChange={handleChange}
            placeholder={t('form.messagePlaceholder')}
          />
        </div>

        <button type="submit">{t('form.submit')}</button>
      </form>
    </section>
  );
}

export default SupportForm;
